// @flow
import Database from 'app/lib/Database';
import LegacyDispatcher from 'app/lib/legacyDispatcher';
import Favicon from 'app/lib/Favicon';
import BaseStore from 'app/stores/BaseStore';

declare var jQuery: {
  ajax: (options: { url: string, data: mixed, complete: Function, success: () => mixed }) => mixed
};

type FaviconKeys = 'failed' | 'passed' | 'started' | 'scheduled';

type FaviconPaths = {
  [FaviconKeys]: string
};

export default class BuildShowStore extends BaseStore {
  constructor(build: mixed, faviconPaths: FaviconPaths) {
    // Call super on the parent store
    super();

    this.build = Database.parse(build);
    this.faviconPaths = faviconPaths;

    // When we receive a build update, update the build and emit an event.
    LegacyDispatcher.on(
      "build:started build:updated build:finished",
      ({ id }) => {
        if (id === this.build.id) {
          this.reload();
        }
      }
    );

    this._updateFavicon();
  }

  getBuild() {
    return this.build;
  }

  setBuild(build: mixed) {
    this.build = build;
    this.emit("change");
    this._updateFavicon();
  }

  reload(data: ?mixed) {
    if (data == null) {
      data = {};
    }

    this.reloadAgain = true;

    if (this.reloading) {
      return;
    }

    this.reloadAgain = false;
    this.reloading = true;

    const reloadDone = () => {
      setTimeout(
        () => {
          this.reloading = false;
          if (this.reloadAgain) {
            this.reload();
          }
        },
        1000
      );
    };

    return jQuery.ajax({
      url: this.build.jsonPath,
      data,
      complete: reloadDone,
      success: (build) => {
        this.setBuild(Database.parse(build));
      }
    });
  }

  _updateFavicon() {
    const iconPath = this.faviconPaths[this._faviconKey(this.build.state, this.build.blockedState)];
    if (iconPath != null) {
      Favicon.update(iconPath);
    }
  }

  _faviconKey(state: string, blockedState: ?string): FaviconKeys {
    switch (state) {
      case "failed":
        return "failed";

      case "canceled":
        return "failed";

      case "canceling":
        return "failed";

      case "not_run":
        return "failed";

      case "blocked":
        switch (blockedState) {
          case "failed":
            return "failed";
          case "running":
            return "started";
          case "passed":
          default:
            return "passed";
        }
      case "passed":
        return "passed";

      case "started":
        return "started";

      default:
        return "scheduled";
    }
  }
}
